import { t } from 'ember-intl';
import Divider from 'tio-ui/components/divider';

<template>
  {{! Income-Driven Loan Forgiveness }}
  <div class="mt-6">
    <h2 class="tio-fg-primary tio-text-xl-semibold">
      {{t "pslf.questions.income_driven.idlf.title"}}
    </h2>
    <p class="pt-4">{{t "pslf.questions.income_driven.idlf.description"}}</p>
    <ul class="p-4 list-disc app-rich-text">
      <li>{{t "pslf.questions.income_driven.idlf.item_1"}}</li>
    </ul>
  </div>

  {{! Am I Eligible? }}
  <div class="mt-6">
    <h2 class="tio-fg-primary tio-text-xl-semibold">{{t "pslf.questions.am_i_eligible"}}</h2>
    <div class="tio-col-flush pt-6 sm:grid sm:grid-cols-2">
      <div class="pr-3">
        <h3 class="font-semibold tio-fg-secondary">
          {{t "pslf.questions.income_driven.borrower_eligibility.title"}}
        </h3>
        <p class="pt-4">{{t "pslf.questions.income_driven.borrower_eligibility.description"}}</p>
      </div>
      <div class="pt-4 sm:pl-3 sm:pt-0">
        <h3 class="font-semibold tio-fg-secondary">
          {{t "pslf.questions.income_driven.loan_types.title"}}
        </h3>
        <p class="pt-4">{{t "pslf.questions.income_driven.loan_types.description"}}</p>
      </div>
    </div>
  </div>

  {{! Plan Details }}
  <div class="mt-6">
    <h2 class="tio-fg-primary tio-text-xl-semibold">{{t "pslf.questions.plan_details"}}</h2>
    <div class="tio-col-flush pt-6 pb-2 sm:grid sm:grid-cols-3">
      <div>
        <p class="pt-4 font-semibold tio-fg-secondary">
          {{t "pslf.questions.income_driven.plan.forgiven_after.title"}}
        </p>
        <p>{{t "pslf.questions.income_driven.plan.forgiven_after.description"}}</p>
      </div>
      <div class="sm:ml-5">
        <p class="pt-4 font-semibold tio-fg-secondary">
          {{t "pslf.questions.income_driven.plan.max_forgiveness.title"}}
        </p>
        <p>{{t "pslf.questions.income_driven.plan.max_forgiveness.description"}}</p>
      </div>
      <div>
        <p class="pt-4 font-semibold tio-fg-secondary">
          {{t "pslf.questions.income_driven.plan.tax_info.title"}}
        </p>
        <p>{{t "pslf.questions.income_driven.plan.tax_info.description"}}</p>
      </div>
    </div>
    <Divider class="my-2" />
    <div class="tio-col-flush sm:grid sm:grid-cols-2">
      <div class="p-3">
        <h3 class="tio-text-lg-semibold tio-fg-secondary">
          {{t "pslf.questions.income_driven.plan.pros.title"}}
        </h3>
        <ul class="p-4 pt-0 list-disc">
          <li>{{t "pslf.questions.income_driven.plan.pros.item_1"}}</li>
        </ul>
      </div>
      <div class="p-3">
        <h3 class="tio-text-lg-semibold tio-fg-secondary">
          {{t "pslf.questions.income_driven.plan.cons.title"}}
        </h3>
        <ul class="p-4 pt-0 list-disc">
          <li>{{t "pslf.questions.income_driven.plan.cons.item_1"}}</li>
          <li>{{t "pslf.questions.income_driven.plan.cons.item_2"}}</li>
        </ul>
      </div>
    </div>
  </div>

  {{! Next Steps }}
  <div class="mt-6">
    <h2 class="tio-fg-primary tio-text-xl-semibold">{{t "pslf.questions.next_steps"}}</h2>
    <div class="tio-col-flush pt-6 sm:grid sm:grid-cols-2">
      <div class="pr-3">
        <h3 class="font-semibold tio-fg-secondary">
          {{t "pslf.questions.teacher.make_the_switch.title"}}
        </h3>
        <ul class="p-4 list-disc app-rich-text">
          <li>{{t "pslf.questions.income_driven.make_the_switch.item_1" htmlSafe=true}}</li>
        </ul>
      </div>
      <div class="pt-4 sm:pl-3 sm:pt-0">
        <h3 class="font-semibold tio-fg-secondary">{{t "pslf.questions.need_more_help.title"}}</h3>
        <p class="pt-4 app-rich-text">{{t
            "pslf.questions.need_more_help.description"
            htmlSafe=true
          }}</p>
      </div>
    </div>
  </div>
</template>
